import { TradeInAemNavStep } from "../../../utils/constants";
import { TradeInCslTz } from "../standalone/tz";

export class TradeInCslTzIntegrated extends TradeInCslTz {
    enabledNavSteps = [TradeInAemNavStep.FindVehicle, TradeInAemNavStep.VehicleDetails, TradeInAemNavStep.VehicleValue];
}
